/* eslint-disable */

import { toast } from 'react-toastify';
import {actions} from 'forms/rrf';
import irelandApi from '../irelandApi';
import store, {history} from '../store';
import ToastMessage from '../components/common/toast-message';

export const getNotifications = (event) => (dispatch) => {
  dispatch({
    type: 'GET_NOTIFICATIONS_LIST_PENDING',
    payLoad: []
  });
  const q = {
    event
  };
  return irelandApi.get('/api/admin/notifications', {params: {q}})
    .then((response) => {
      dispatch({
        type: 'GET_NOTIFICATIONS_LIST_FULFILLED',
        payLoad: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: 'GET_NOTIFICATIONS_LIST_REJECTED',
        payLoad: error.data
      });
    });
};

export const getNewNotificationPins = () => (dispatch) => {
  dispatch({
    type: 'GET_NOTIFICATION_PINS_PENDING',
    payLoad: []
  });
  return irelandApi.get('/api/admin/notifications/new')
    .then((response) => {
      dispatch({
        type: 'GET_NOTIFICATION_PINS_FULFILLED',
        payLoad: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: 'GET_NOTIFICATION_PINS_REJECTED',
        payLoad: error.data
      });
    });
};

export const getNotification = id => (dispatch) => {
  dispatch({
    type: 'GET_NOTIFICATION_PENDING',
    payLoad: []
  });
  return irelandApi.get(`/api/admin/notifications/${id}`)
    .then((response) => {
      const attributes = response.data.data.attributes;
      const data = {
        event: attributes.event || 'pin',
        to_associated_user: attributes.to_associated_user.toString() || 'true',
        custom_to: attributes.custom_to || '',
        email: attributes.email || false,
        email_subject: attributes.email_subject || '',
        email_body: attributes.email_body || '',
        sms: attributes.sms || false,
        sms_body: attributes.sms_body || '',
        site_message: attributes.site_message || false,
        site_body: attributes.site_body || '',
        push: attributes.push || false,
        push_title: attributes.push_title || '',
        push_body: attributes.push_body || '',
      };
      store.dispatch(actions.load('deep.admin_notification_edit', data));
      dispatch({
        type: 'GET_NOTIFICATION_FULFILLED',
        payLoad: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: 'GET_NOTIFICATION_REJECTED',
        payLoad: error.data
      });
    });
};

const createRequestData = (payLoad) => {
  // The push checkbox keeps its value, disabled, when Custom To is picked; only the associated
  // user can be pushed to, and the API refuses push otherwise. The push title and body are sent
  // either way, so admins can prepare the wording with push off and tick it on later.
  const push = payLoad.to_associated_user === 'true' && payLoad.push;
  const notification = {
    event: payLoad.event,
    to_associated_user: (payLoad.to_associated_user === 'true'), // checkbox works with string value
    email: payLoad.email,
    sms: payLoad.sms,
    site_message: payLoad.site_message,
    push,
    push_title: payLoad.push_title,
    push_body: payLoad.push_body
  };

  if (!(payLoad.to_associated_user === 'true')) {
    notification.custom_to = payLoad.custom_to;
  }
  if (payLoad.email) {
    notification.email_subject = payLoad.email_subject;
    notification.email_body = payLoad.email_body;
  }
  if (payLoad.sms) {
    notification.sms_body = payLoad.sms_body;
  }
  if (payLoad.site_message) {
    notification.site_body = payLoad.site_body;
  }
  return notification;
};

export const saveNotification = payLoad => irelandApi.post('/api/admin/notifications', {notification: createRequestData(payLoad)})
  .then((response) => {
    toast.success(<ToastMessage iconStyle="success" message="Notification saved successfully"/>);
    history.push('/admin/notifications');
  })
  .catch((error) => {
    toast.error(<ToastMessage iconStyle="error"
                                               message="An error occurred during save notification"/>);
    store.dispatch(actions.resetValidity('deep.admin_notification_edit'));
    const data = {
      ...error.response.data.errors
    };
    return Promise.reject(data);
  });

export const updateNotification = (id, payLoad) => irelandApi.put(`/api/admin/notifications/${id}`, {notification: createRequestData(payLoad)})
  .then((response) => {
    toast.success(<ToastMessage iconStyle="success" message="Notification updated successfully"/>);
    history.push('/admin/notifications');
  })
  .catch((error) => {
    toast.error(<ToastMessage iconStyle="error"
                                               message="An error occurred during update notification"/>);

    const data = {
      ...error.response.data.errors
    };
    return Promise.reject(data);
  });
//
export const deleteNotification = id => (dispatch) => {
  dispatch({type: 'DELETE_NOTIFICATION_PENDING'});
  return irelandApi.delete(`/api/admin/notifications/${id}`)
    .then((response) => {
      toast.success(<ToastMessage iconStyle="success"
                                                 message="Notification has been deleted successfully"/>);
      dispatch({
        type: 'DELETE_NOTIFICATION_FULFILLED',
        payLoad: response.data,
        id
      });
      dispatch(getNotifications());
    })
    .catch((error) => {
      toast.error(<ToastMessage iconStyle="error"
                                               message="An error occured during notification delete"/>);
      dispatch({
        type: 'DELETE_NOTIFICATION_REJECTED',
        payLoad: error.data
      });
      const data = {
        ...error.response.data
      };
      return Promise.reject(data);
    });
};
